import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { Typography } from "PFComponents/typography";
import { Variant } from "PFComponents/typography/typography.types";

import css from "./emphasized_text.module.scss";

type EmphasizedTextProps = {
  text: string;
  tag?: string;
  variant?: Variant;
  emphasizedVariant?: Variant;
  emphasizedClassName?: string;
  className?: string;
};

export const EmphasizedText = ({
  text,
  tag = "em",
  variant = "bodyRegular",
  emphasizedVariant = "bodyBold",
  emphasizedClassName,
  className
}: EmphasizedTextProps) => {
  const startTag = `<${tag}>`;
  const endTag = `</${tag}>`;

  const parts = text.replaceAll(endTag, startTag).split(startTag);

  return (
    <span className={className}>
      {parts.map((part, index) =>
        !isEmpty(part) ? (
          <Typography
            key={index}
            variant={index % 2 === 0 ? variant : emphasizedVariant}
            className={index % 2 === 0 ? css.textPart : classNames(css.textPart, emphasizedClassName)}
          >
            {part}
          </Typography>
        ) : null
      )}
    </span>
  );
};
